var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConnected = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 26.458 26.458",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light-circle-fill",
    gradientTransform: "matrix(1.6202 0 0 1.6202 -208.26 -377.58)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5199",
    x1: 76.89,
    x2: 84.213,
    y1: 96.73,
    y2: 96.73,
    gradientTransform: "matrix(1.2729 0 0 1.2729 -22.91 -26.356)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#light-circle-fill"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -270.54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5713 0 0 1.5713 -114.97 131.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.463 99.915 7.7607-6.4212-3.7847-3.1468v12.779l3.8059-3.3807-7.8564-6.4637",
    fill: "none",
    stroke: "url(#linearGradient5199)",
    strokeWidth: 1.3471
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.747 94.627a2.9769 2.9769 0 0 1 0.01593 3.7839l-2.3062-1.8823z",
    fill: "url(#light-circle-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.773 92.884-1.0682 0.88667c1.3202 1.5927 1.329 3.8968 0.02105 5.4996-0.0025 0.0015-0.0062-3.05e-4 1.0774 0.8841 1.7296-2.1189 1.7169-5.1658-0.03026-7.2703z",
    fill: "url(#light-circle-fill)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConnected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/connected.af4b149c9145b4b606c32cafd890b544.svg";